<template>
  <div class="text-center">
    <v-dialog
        v-model="dialog"
        width="573"
    >
      <template v-slot:activator="{ on, attrs }">
        <div>
          <v-icon
              v-bind="attrs"
              v-on="on"
              color="onuGreyColor"
          >
            {{ `mdi-delete-outline` }}
          </v-icon>
        </div>
      </template>

      <v-card class="px-6 pb-9 pt-3">
        <div class="modal-card-close-icon-style" @click="dialog = !dialog">
          <v-icon style="cursor: pointer">{{ `mdi-close` }}</v-icon>
        </div>
        <v-card-title class="modal-card-title-style">
          <div class="text-center">삭제하기</div>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <div style="margin: 24px 36px 24px 36px">
            <div class="text-center">
              정말 삭제하시겠어요?
            </div>
            <div class="text-center">
              삭제된 {{ domain }}는 다시 불러올 수 없습니다.
            </div>
          </div>

          <div class="d-flex justify-center">
            <slot></slot>
          </div>
        </v-card-text>

        <v-card-actions class="d-flex justify-space-between">
          <div style="width: 100%; margin-right: 24px;">
            <v-btn
                color="grey"
                block
                outlined
                @click="dialog = !dialog"
            >
              취소
            </v-btn>
          </div>
          <div style="width: 100%">
            <v-btn
                color="primary"
                block
                outlined
                @click="deleteDomain"
            >
              삭제
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'DeleteConfirm',
  props: ['domain'],
  data: () => ({
    dialog: false,
  }),
  methods: {
    deleteDomain() {
      this.$emit('delete-domain')
    }
  }
}
</script>

<style scoped>

</style>